<mat-card appearance="outlined">
  <mat-card-header> <h3>Zet tags voor deze ploeg</h3> </mat-card-header>
  <mat-card-content>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
      <div fxFlex="50%">
        <mat-chip-listbox>
          @if (groupTags$ | async; as groupTags) {
            @for (groupTag of groupTags; track groupTag) {
              <mat-chip-option
                (click)="removeTagFromGroup(groupTag)"
                >
                {{ groupTag.tag.value }}
                <mat-icon>clear</mat-icon>
              </mat-chip-option>
            }
            @if (groupTags.length === 0) {
              <p>Ploeg heeft nog geen tags.</p>
            }
          }
        </mat-chip-listbox>
      </div>
      <mat-form-field fxFlex>
        <mat-label>Zoek een tag </mat-label>
        <input
          type="text"
          matInput
          [formControl]="autocompleteForm"
          [matAutocomplete]="auto"
          />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            @for (tag of allowedTags$ | async; track tag) {
              <mat-option [value]="tag">
                {{ tag.value }}
              </mat-option>
            }
          </mat-autocomplete>
          <mat-hint>
            Typ een niet bestaande naam (met hoofdletters en spaties) om een nog
            niet bestaande tag toe te voegen
          </mat-hint>
        </mat-form-field>
        <button
          mat-button
          (click)="addTag()"
          [disabled]="!autocompleteForm.valid"
          >
          Toevoegen
        </button>
      </div>
    </mat-card-content>
  </mat-card>
